// Native
import {useRef, useState} from "react"
import {Badge, Box, Button, ButtonGroup, Flex, Separator, Stack, Text} from "@chakra-ui/react"

// Custom
import {Parts, UI} from "components"
import {toaster, API} from "config"
import useUser from "hooks/useUser"

export default function Profile() {

    const avatarInputRef = useRef()
    const user = useUser()
    const [loading, setLoading] = useState(false)

    const first_name = user.data?.name?.split(' ')?.[0]
    const last_name = user.data?.name?.split(' ')?.[1]
    const indication_url = `https://bonifi.ca/${user.data?.username}`

    const handleChangeUsername = async (username) => {
        if (username === user.data.username) return
        setLoading('username')

        try {
            await API.put(`/me`, {username})
            toaster.create({title: 'Seu nome de usuário foi alterado.', type: 'success'})
            user.refetch()
        } catch (err) {
            toaster.create({
                title: 'Não foi possível atualizar o nome de usuário.',
                description: err?.response?.data?.message,
                type: 'warning'
            })
        }

        setLoading(false)
    }

    const handleChangeAvatar = async (avatar_file) => {
        if (!avatar_file) return
        setLoading('avatar')

        try {
            const form = new FormData()
            form.append('avatar_file', avatar_file)
            form.append('_method', 'put')
            await API.post('/me', form, {headers: {"Content-Type": "multipart/form-data"}})
            toaster.create({title: 'Imagem de avatar atualizada!', type: 'success'})
            user.refetch()
        } catch (err) {
            toaster.create({
                title: 'Não foi possível enviar sua imagem de avatar. Tente novamente',
                description: err?.response?.data?.message,
                type: 'warning'
            })
        }
        setLoading(false)
    }

    return (
        <UI.Box>
            <Stack gap={4}>

                <Flex direction="column" alignItems="center" justifyContent="center">
                    <input ref={avatarInputRef} type="file" accept="image/*" style={{display: 'none'}}
                           onChange={e => handleChangeAvatar(e.target.files?.[0])}/>
                    <UI.Tooltip content="Clique para alterar o avatar">
                        <UI.Pressable disabled={!!loading} onClick={() => avatarInputRef.current.click()}><UI.Avatar
                            src={user.data?.avatar_url} size="2xl" colorPalette="orange"
                            name={user.data?.name}/></UI.Pressable>
                    </UI.Tooltip>
                    <Text>{first_name} {last_name}</Text>
                    <Badge>{user.data?.consultant?.career?.current_career?.title}</Badge>
                </Flex>

                <Separator/>

                <UI.Editable
                    label="Nome de usuário:"
                    defaultValue={user.data?.username}
                    previewProps={{fontSize: 'lg', fontWeight: 'bold'}}
                    helper="Este é o nome de usuário que aparecerá no seu link de indicação."
                    onValueCommit={e => handleChangeUsername(e.value)}
                    disabled={!!loading}
                />

                <UI.Clipboard label="Link de indicação:" size="sm" value={indication_url} colorPalette="orange"
                              inputProps={{fontWeight: 'bold', color: 'orange.fg'}}/>

                <ButtonGroup size="xs">
                    <Button variant="subtle" disabled><UI.Icon name="email"/> Convidar por e-mail</Button>
                    <Button variant="ghost" colorPalette="orange"
                            onClick={() => window.open(indication_url)}>Abrir <UI.Icon name="popup"/></Button>
                </ButtonGroup>

                <UI.Alert size="sm" colorPalette="gray">
                    O link de indicação da Bonífica mudou, ficou mais curto e elegante. Porém os links anteriores
                    ainda
                    funcionarão normalmente.
                </UI.Alert>
            </Stack>

            <Separator my={6}/>

            <Box>
                <Parts.Widgets.PointsBonus/>
            </Box>

        </UI.Box>

    )
}